import React from "react";
import PropTypes from "prop-types";
import PageBuilder from "../../helpers/PageBuilder";
import Device from "../../constants/Device";
import {
  RenderHomePageSchema,
  formatImageUrlByDevice,
} from "../../helpers/Helper";
import Sites from "../../constants/Sites";
import Meta from "../Meta";
import { useAppContext } from "@components/Provider";
import CarouselHeroCard from "../CardSlider/CarouselHeroCard";

import styles from "./ContentHome.module.css";
import "./ContentHome.css";

const ContentHome = (props) => {
  const {vars} = props || {};
  props = props.HomeData;
  let { data, host, siteId, router, isMobile, deviceType, subscriberCookie } =
      useAppContext(),
    [contentHomePageData] = props.data,
    { post } = contentHomePageData.Index || {},
    { SiteSettings } = data || {},
    siteName = SiteSettings.site_name,
    pageBuilderOptions = {
      deviceSize: Device.DESKTOP,
      Newsletter_Settings: SiteSettings.newsletter_settings,
      homePage: true,
    };
  let useLGImage = false;
  if (deviceType == Device.DESKTOP && siteId == Sites.EARLYBIRDBOOKS)
    useLGImage = true;

  let isHeader =
    siteId == Sites.EARLYBIRDBOOKS
      ? router.asPath == "/"
        ? isMobile
          ? true
          : false
        : true
      : true;
  return (
    <div
      className={
        isHeader == true
          ? [
              styles["contentHomepage"],
              "contentHomepage",
              styles["topPadding"],
              "topPadding",
            ].join(" ")
          : [styles["contentHomepage"], "contentHomepage"].join(" ")
      }
      style={{
        "--subscriberCookie": subscriberCookie ? 1 : 0,
        "--topPadding768": `${
          siteId != Sites.EARLYBIRDBOOKS
            ? !subscriberCookie
              ? siteId === Sites.OPENROADMEDIA
                ? "109px"
                : "155px"
              : "100px"
            : "50px"
        }`,
        "--topPadding712": `${
          !subscriberCookie
            ? siteId == Sites.EARLYBIRDBOOKS
              ? "0"
              : "15px"
            : "15px"
        }`,
        ...vars,
      }}
    >
      <Meta
        url={props.pageUrl}
        post={post}
        siteName={siteName}
        isNewAppRouter={true}
      />

      {/* Part of older EBB homepage. See https://openroadmedia.atlassian.net/browse/ORMTECH-1810 */}
      {siteId == Sites.EARLYBIRDBOOKS && (
        <div className="CarouselHeroBookSlider">
          <CarouselHeroCard
            imageUrl={
              post.featured_media
                ? formatImageUrlByDevice(
                    post.featured_media.name,
                    props.deviceSize,
                    props.imageSize,
                    useLGImage
                  )
                : ""
            }
            alt={post.featured_media ? post.featured_media.alt_text : ""}
          />
          <div className="overlay"></div>
        </div>
      )}
      <PageBuilder
        post={post}
        pageBuilderOptions={pageBuilderOptions}
        siteId={siteId}
        isMobile={isMobile}
        classes={[styles["zeroMargin"]]}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={RenderHomePageSchema(
          SiteSettings,
          post,
          host,
          siteId
        )}
      />
    </div>
  );
};

ContentHome.propTypes = {
  props: PropTypes.object,
};

export default ContentHome;
